// src/redux/settingsPages/emailPreferences/emailPreferencesActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import EmailPreferencesAPI from './emailPreferencesAPI';

export const fetchEmailPreferences = createAsyncThunk(
  'emailPreferences/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await EmailPreferencesAPI.getPreferences();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load notification settings');
    }
  }
);

export const updateEmailPreferences = createAsyncThunk(
  'emailPreferences/update',
  async (patch, { rejectWithValue }) => {
    try {
      return await EmailPreferencesAPI.updatePreferences(patch);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update notification settings');
    }
  }
);
